/**
 * Zod Formik Adaptor
 * This is an embedded fork of https://github.com/robertLichtnow/zod-formik-adapter/blob/master/index.ts
 * Copyright is with the original author.
 *
 * We need to import some slightly different files from Zod which we can't achieve through package patching.
 * This should be remvoed once we use packages which support Standard Schema.
 */
import { z } from "zod";
export class ValidationError extends Error {
    name = "ValidationError";
    inner = [];
    constructor(message) {
        super(message);
    }
}
function createValidationError(e) {
    const error = new ValidationError(e.message);
    error.inner = e.issues.map((err) => ({
        message: err.message,
        path: err.path.join("."),
    }));
    return error;
}
/**
 * Wrap your zod schema in this function when providing it to Formik's validation schema prop
 * @param schema The zod schema
 * @returns An object containing the `validate` method expected by Formik
 */
export function toFormikValidationSchema(schema) {
    return {
        async validate(obj) {
            try {
                await schema.parseAsync(obj);
            }
            catch (err) {
                throw createValidationError(err);
            }
        },
    };
}
function createValidationResult(error) {
    const result = {};
    for (const x of error.issues) {
        // Stryker disable next-line MethodExpression -- vendored fork: filter(Boolean) removes falsy array-index segments (e.g. 0); testing requires a complex Zod array schema and is disproportionate
        result[x.path.filter(Boolean).join(".")] = x.message;
    }
    return result;
}
/**
 * Wrap your zod schema in this function when providing it to Formik's validate prop
 * @param schema The zod schema
 * @returns An validate function as expected by Formik
 */
export function toFormikValidate(schema) {
    return async (values) => {
        const result = await schema.safeParseAsync(values);
        if (!result.success) {
            return createValidationResult(result.error);
        }
    };
}
//# sourceMappingURL=zod-formik-adaptor.js.map